import { Get } from "#src/HttpClient.ts";
import { type Pinia } from "pinia";

const controller = "/strife/v1/agents";

interface Agent {
  id: number;
  name: string;
  url: string;
}

export async function getAllAgents(pinia: Pinia, npn: string | number) {
  const params: { npn?: string | number } = {};
  if (npn) params.npn = npn;
  const { data } = await Get(pinia, { url: controller, params });
  const agents = data.agents as Agent[];
  agents.sort((a, b) => a.name.localeCompare(b.name));
  return agents;
}
